export default "__VITE_ASSET__BRgC4U0e__"